module.exports = __webpack_public_path__ + "img/sop_library.dc3c453c.png";